export default function DocumentSupportingDocumentDirective() {
  return {
    template: require('./document-supporting-document.html'),
    scope: {
      policyDocumentId: '=',
      canEdit: '=',
      canDelete: '=',
      supportingDocument: '=',
    },
    controller: 'DocumentSupportingDocumentController',
    controllerAs: 'documentSupportingDocumentVM',
    bindToController: true,
    replace: true
  };
}
